import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../styles/styles';
import { opportunityChartTooltipChrome } from '../../Opportunities/helpers/opportunityChartTooltipChrome';

export const styleSheet = StyleSheet.create({
	trackingSince: {
		margin: 0,
		marginTop: SPACE[12],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	kpi: {
		gridColumn: 'span 3',
	},
	card: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		marginBlock: SPACE[16],
		padding: SPACE[24],
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: `0 1px 3px ${THEME.colors.border.main}`,
		// Recharts colors legend text with the series color inline (hence !important).
		...CssSelectors.allDescendants(
			{ color: `${THEME.colors.text.main} !important`, fontSize: THEME.typography.fontSizes.xs },
			'.recharts-legend-item-text'
		),
	},
	cardHeader: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: SPACE[16],
	},
	cardTitle: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	cardSubtitle: {
		margin: 0,
		marginTop: SPACE[4],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	note: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	movementBody: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1fr) 240px',
		gap: SPACE[32],
		alignItems: 'center',
		[THEME.queries.md]: {
			gridTemplateColumns: 'minmax(0, 1fr)',
		},
	},
	totals: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	totalsHeading: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.light,
		textTransform: 'uppercase',
	},
	totalRow: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
	},
	swatch: {
		width: 12,
		height: 12,
		flexShrink: 0,
	},
	swatchNewBusiness: {
		background: THEME.colors.chart.levBlue,
	},
	swatchRenewed: {
		background: THEME.colors.chart.aceGray,
	},
	swatchLost: {
		background: THEME.colors.chart.magicOrange,
	},
	swatchAssumedCancelled: {
		background: THEME.colors.chart.illusionYellow,
	},
	totalLabel: {
		flexGrow: 1,
	},
	totalValue: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	tableScroll: {
		overflowX: 'auto',
	},
	table: {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	th: {
		padding: `${SPACE[8]}px ${SPACE[12]}px`,
		textAlign: 'right',
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.light,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		whiteSpace: 'nowrap',
	},
	td: {
		padding: `${SPACE[8]}px ${SPACE[12]}px`,
		textAlign: 'right',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		whiteSpace: 'nowrap',
	},
	tooltip: {
		...opportunityChartTooltipChrome,
		maxWidth: 260,
	},
	tooltipTitle: {
		marginBottom: SPACE[4],
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	tooltipLine: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	tooltipNote: {
		margin: 0,
		marginTop: SPACE[4],
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	firstColumn: {
		textAlign: 'left',
	},
	monthCell: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
	},
	strong: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	empty: {
		margin: 0,
		paddingBlock: SPACE[32],
		textAlign: 'center',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	pending: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[12],
		padding: SPACE[24],
		background: THEME.colors.background.main,
		border: `1px dashed ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
	},
	pendingIcon: {
		flexShrink: 0,
		color: THEME.colors.text.light,
	},
	pendingTitle: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
	},
	pendingText: {
		margin: 0,
		marginTop: SPACE[4],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
